import { render, staticRenderFns } from "./multiple-radialbars.vue?vue&type=template&id=67927283&"
import script from "./multiple-radialbars.vue?vue&type=script&lang=js&"
export * from "./multiple-radialbars.vue?vue&type=script&lang=js&"
import style0 from "./multiple-radialbars.vue?vue&type=style&index=0&id=67927283&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports